import { PLATFORM } from 'src/config/api';

export const propertyJsonList = [
    { key: 'default', name: '선택안함' },
    { key: 'processedFood', name: '가공식품' },
    { key: 'fruit', name: '농산물' },
    { key: 'fish', name: '수산물' },
    { key: 'meat', name: '축산물' },
];

export const propertyJsonDefaultData = {
    default: [
        {
            key: `상품 정보고시`,
            placeholder: '',
            value: ``,
        },
        {
            key: `용량 · 중량`,
            placeholder: '',
            value: ``,
        },
        {
            key: `원산지`,
            placeholder: '',
            value: ``,
        },
        {
            key: `소비자 상담 관련 전화번호`,
            placeholder: '',
            value: `주식회사 퍼스트엔터테인먼트 ｜ 1644-3353`,
        },
        {
            key: `배송`,
            placeholder: '',
            value: `상품별 옵션에 기재된 출고일에 출고됩니다.
옵션에 기재되지 않은 상품은 평일 기준 익일 출고됩니다.
배송기간은 평일 기준 1~3일 소요되는 점 참고 부탁드립니다.
상품 특성상 ±10% 오차가 있을 수 있습니다.
상품 특성상 사진과 다를 수 있습니다.
상품의 품질이 기준에 못 미치거나 수량이 부족할 경우 배송 지연 또는 주문이 취소될 수 있습니다.`,
        },
        {
            key: `반품`,
            placeholder: '',
            value: `상품 특성상 변심반품은 불가합니다.
손상, 훼손이 아닌 개인 입맛차이에 따른 반품은 불가합니다.`,
        },
        {
            key: `부정불량식품신고`,
            placeholder: '',
            value: `국번없이 1399`,
        },
    ],
    meat: [
        {
            key: '품목 또는 명칭',
            placeholder: '',
            value: '',
        },
        {
            key: '포장단위별 용량(중량), 수량, 크기',
            placeholder: '',
            value: `용량 : 
수량 :
크기 :`,
        },
        {
            key: '원재료명 및 함량',
            placeholder: '',
            value: ``,
        },
        {
            key: '제조연월일',
            placeholder: '',
            value: ``,
        },
        {
            key: '소비기한 또는 품질유지기한',
            placeholder: '',
            value: ``,
        },
        {
            key: '원산지',
            placeholder: '',
            value: ``,
        },
        {
            key: '생산자 / 생산지',
            placeholder: '',
            value: `생산자 : 
생산지 :`,
        },
        {
            key: '포장재질',
            placeholder: '',
            value: ``,
        },
        {
            key: '포장식품 유형 및 용도재질',
            placeholder: '',
            value: `식품 유형 : 
용도 :`,
        },
        {
            key: '축산물 이력법에 따른 이력 관리 대상 축산물 유무',
            placeholder: '',
            value: ``,
        },
        {
            key: '세부 품목군별 표시사항',
            placeholder: '',
            value: `등급 : 
축산물 이력정보 :
품목보고번호 : `,
        },
        {
            key: '상품구성',
            placeholder: '',
            value: ``,
        },
        {
            key: '보관방법 또는 취급방법',
            placeholder: '',
            value: ``,
        },
        {
            key: '소비자 안전을 위한 주의사항',
            placeholder: '',
            value: ``,
        },
        {
            key: `소비자 상담 관련 전화번호`,
            placeholder: '',
            value: `주식회사 퍼스트엔터테인먼트 ｜ 1644-3353`,
        },
        {
            key: `배송`,
            placeholder: '',
            value: `상품별 옵션에 기재된 출고일에 출고됩니다.
옵션에 기재되지 않은 상품은 평일 기준 익일 출고됩니다.
배송기간은 평일 기준 1~3일 소요되는 점 참고 부탁드립니다.
상품 특성상 ±10% 오차가 있을 수 있습니다.
상품 특성상 사진과 다를 수 있습니다.
상품의 품질이 기준에 못 미치거나 수량이 부족할 경우 배송 지연 또는 주문이 취소될 수 있습니다.`,
        },
        {
            key: `반품`,
            placeholder: '',
            value: `상품 특성상 변심반품은 불가합니다.
손상, 훼손이 아닌 개인 입맛차이에 따른 반품은 불가합니다.`,
        },
        {
            key: `부정불량식품신고`,
            placeholder: '',
            value: `국번없이 1399`,
        },
    ],
    fish: [
        {
            key: '품목 또는 명칭',
            placeholder: '',
            value: '',
        },
        {
            key: '포장단위별 용량(중량), 수량, 크기',
            placeholder: '',
            value: `용량 : 
수량 :
크기 :`,
        },
        {
            key: '원재료명 및 함량',
            placeholder: '',
            value: ``,
        },
        {
            key: '제조연월일',
            placeholder: '',
            value: ``,
        },
        {
            key: '소비기한 또는 품질유지기한',
            placeholder: '',
            value: ``,
        },
        {
            key: '원산지',
            placeholder: '',
            value: ``,
        },
        {
            key: '생산자 / 생산지',
            placeholder: '',
            value: `생산자 : 
생산지 :`,
        },
        {
            key: '포장재질',
            placeholder: '',
            value: ``,
        },
        {
            key: '세부 품목군별 표시사항',
            placeholder: '',
            value: ``,
        },
        {
            key: '상품구성',
            placeholder: '',
            value: ``,
        },
        {
            key: '보관방법 또는 취급방법',
            placeholder: '',
            value: ``,
        },
        {
            key: '소비자 안전을 위한 주의사항',
            placeholder: '',
            value: ``,
        },
        {
            key: `소비자 상담 관련 전화번호`,
            placeholder: '',
            value: `주식회사 퍼스트엔터테인먼트 ｜ 1644-3353`,
        },
        {
            key: `배송`,
            placeholder: '',
            value: `상품별 옵션에 기재된 출고일에 출고됩니다.
옵션에 기재되지 않은 상품은 평일 기준 익일 출고됩니다.
배송기간은 평일 기준 1~3일 소요되는 점 참고 부탁드립니다.
상품 특성상 ±10% 오차가 있을 수 있습니다.
상품 특성상 사진과 다를 수 있습니다.
상품의 품질이 기준에 못 미치거나 수량이 부족할 경우 배송 지연 또는 주문이 취소될 수 있습니다.`,
        },
        {
            key: `반품`,
            placeholder: '',
            value: `상품 특성상 변심반품은 불가합니다.
손상, 훼손이 아닌 개인 입맛차이에 따른 반품은 불가합니다.`,
        },
        {
            key: `부정불량식품신고`,
            placeholder: '',
            value: `국번없이 1399`,
        },
    ],
    fruit: [
        {
            key: '품목 또는 명칭',
            placeholder: '',
            value: '',
        },
        {
            key: '포장단위별 용량(중량), 수량, 크기',
            placeholder: '',
            value: `용량 : 
수량 :
크기 :`,
        },
        {
            key: '원재료명 및 함량',
            placeholder: '',
            value: ``,
        },
        {
            key: '제조연월일',
            placeholder: '',
            value: ``,
        },
        {
            key: '소비기한 또는 품질유지기한',
            placeholder: '',
            value: ``,
        },
        {
            key: '원산지',
            placeholder: '',
            value: ``,
        },
        {
            key: '생산자 / 생산지',
            placeholder: '',
            value: `생산자 : 
생산지 :`,
        },
        {
            key: '포장재질',
            placeholder: '',
            value: ``,
        },
        {
            key: `1. 농수산물 품질관리법에 따른 유전자변형농수산물 표시, 지리적표시
2. “수입식품안전관리 특별법에 따른수입신고”를 필함의 문구`,
            placeholder: '',
            value: `농수산물 표시 : 
지리적 표시 : 
수입신고 문구 :`,
        },
        {
            key: `상품구성`,
            placeholder: '',
            value: ``,
        },
        {
            key: `보관방법 또는 취급방법`,
            placeholder: '',
            value: ``,
        },
        {
            key: `소비자 안전을 위한 주의사항`,
            placeholder: '',
            value: ``,
        },
        {
            key: `소비자 상담 관련 전화번호`,
            placeholder: '',
            value: `주식회사 퍼스트엔터테인먼트 ｜ 1644-3353`,
        },
        {
            key: `배송`,
            placeholder: '',
            value: `상품별 옵션에 기재된 출고일에 출고됩니다.
옵션에 기재되지 않은 상품은 평일 기준 익일 출고됩니다.
배송기간은 평일 기준 1~3일 소요되는 점 참고 부탁드립니다.
상품 특성상 ±10% 오차가 있을 수 있습니다.
상품 특성상 사진과 다를 수 있습니다.
상품의 품질이 기준에 못 미치거나 수량이 부족할 경우 배송 지연 또는 주문이 취소될 수 있습니다.`,
        },
        {
            key: `반품`,
            placeholder: '',
            value: `상품 특성상 변심반품은 불가합니다.
손상, 훼손이 아닌 개인 입맛차이에 따른 반품은 불가합니다.`,
        },
        {
            key: `부정불량식품신고`,
            placeholder: '',
            value: `국번없이 1399`,
        },
    ],
    processedFood: [
        {
            key: '제품명',
            placeholder: '',
            value: '',
        },
        {
            key: '식품의 유형',
            placeholder: '',
            value: '',
        },
        {
            key: '생산자',
            placeholder: '',
            value: '',
        },
        {
            key: '소재지',
            placeholder: '',
            value: '',
        },
        {
            key: '제조연월일',
            placeholder: '',
            value: '',
        },
        {
            key: '소비기한 또는 품질유지기한',
            placeholder: '',
            value: '',
        },
        {
            key: '포장단위별 내용물의 용량(중량), 수량',
            placeholder: '',
            value: `용량 : 
중량 :`,
        },
        {
            key: '원재료명 및 함량',
            placeholder: '',
            value: ``,
        },
        {
            key: '포장재질',
            placeholder: '',
            value: ``,
        },
        {
            key: `영양성분`,
            placeholder: '',
            value: ``,
        },
        {
            key: `유전자변형식품에 해당하는 경우의 표시`,
            placeholder: '',
            value: ``,
        },
        {
            key: `보관방법 또는 취급방법`,
            placeholder: '',
            value: ``,
        },
        {
            key: `소비자 안전을 위한 주의사항`,
            placeholder: '',
            value: ``,
        },
        {
            key: `소비자 상담 관련 전화번호`,
            placeholder: '',
            value: `주식회사 퍼스트엔터테인먼트 ｜ 1644-3353`,
        },
        {
            key: `배송`,
            placeholder: '',
            value: `상품별 옵션에 기재된 출고일에 출고됩니다.
옵션에 기재되지 않은 상품은 평일 기준 익일 출고됩니다.
배송기간은 평일 기준 1~3일 소요되는 점 참고 부탁드립니다.
상품 특성상 ±10% 오차가 있을 수 있습니다.
상품 특성상 사진과 다를 수 있습니다.
상품의 품질이 기준에 못 미치거나 수량이 부족할 경우 배송 지연 또는 주문이 취소될 수 있습니다.`,
        },
        {
            key: `반품`,
            placeholder: '',
            value: `상품 특성상 변심반품은 불가합니다.
손상, 훼손이 아닌 개인 입맛차이에 따른 반품은 불가합니다.`,
        },
        {
            key: `부정불량식품신고`,
            placeholder: '',
            value: `국번없이 1399`,
        },
    ],
};

export const marketPropertyJsonList = [
    { key: 'default', name: '선택안함' },
    { key: 'cosmetics', name: '화장품' },
    { key: 'fashion', name: '패션잡화' },
    { key: 'children', name: '어린이' },
    { key: 'appliances', name: '가전' },
    { key: 'food', name: '식품' },
];

export const marketPropertyJsonDefaultData = {
    default: [
        {
            key: `제품명`,
            placeholder: '',
            value: ``,
        },
        {
            key: `변심반품 택배비`,
            placeholder: '',
            value: ``,
        },
        {
            key: `배송`,
            placeholder: '',
            value: `주문 및 결제 완료 후 3~7일 이내 출고됩니다.`,
        },
        {
            key: `용량 및 사이즈`,
            placeholder: '',
            value: ``,
        },
        {
            key: `생산자 / 수입자`,
            placeholder: '',
            value: ``,
        },
        {
            key: `제조년원 / 소비기한`,
            placeholder: '',
            value: ``,
        },
        {
            key: `제조국`,
            placeholder: '',
            value: ``,
        },
        {
            key: `취급시 주의사항`,
            placeholder: '',
            value: ``,
        },
        {
            key: `품질 보증기준`,
            placeholder: '',
            value: ``,
        },
        {
            key: `A/S 책임자와 전화번호`,
            placeholder: '',
            value: ``,
        },
        {
            key: `소비자 상담 관련 전화번호`,
            placeholder: '',
            value:
                PLATFORM === 'ru' || PLATFORM === 'jikgu'
                    ? `리유코스메틱 | 062-450-7700`
                    : `주식회사 한국유기농 ｜ 062-450-7700`,
        },
    ],
    cosmetics: [
        {
            key: `제품명`,
            placeholder: '',
            value: ``,
        },
        {
            key: `용량 및 중량`,
            placeholder: '',
            value: ``,
        },
        {
            key: `변심반품 택배비`,
            placeholder: '',
            value: ``,
        },
        {
            key: `배송`,
            placeholder: '',
            value: `주문 및 결제 완료 후 3~7일 이내 출고됩니다.`,
        },
        {
            key: `제품 주요 사항`,
            placeholder: '',
            value: ``,
        },
        {
            key: `사용방법`,
            placeholder: '',
            value: ``,
        },
        {
            key: `제조일자 / 사용기한`,
            placeholder: '',
            value: ``,
        },
        {
            key: `전성분`,
            placeholder: '',
            value: ``,
        },
        {
            key: `화장품 제조업자 / 판매업자`,
            placeholder: '',
            value: ``,
        },
        {
            key: `사용시 주의사항`,
            placeholder: '',
            value: ``,
        },
        {
            key: `품질 보증기준`,
            placeholder: '',
            value: ``,
        },
        {
            key: `고객상담실`,
            placeholder: '',
            value: ``,
        },
        {
            key: `소비자 상담 관련 전화번호`,
            placeholder: '',
            value:
                PLATFORM === 'ru' || PLATFORM === 'jikgu'
                    ? `리유코스메틱 | 062-450-7700`
                    : `주식회사 한국유기농 ｜ 062-450-7700`,
        },
    ],
    fashion: [
        {
            key: `제품명`,
            placeholder: '',
            value: ``,
        },
        {
            key: `변심반품 택배비`,
            placeholder: '',
            value: ``,
        },
        {
            key: `배송`,
            placeholder: '',
            value: `주문 및 결제 완료 후 3~7일 이내 출고됩니다.`,
        },
        {
            key: `소재`,
            placeholder: '',
            value: ``,
        },
        {
            key: `색상 / 사이즈`,
            placeholder: '',
            value: ``,
        },
        {
            key: `제조자 / 수입자`,
            placeholder: '',
            value: ``,
        },
        {
            key: `제조국`,
            placeholder: '',
            value: ``,
        },
        {
            key: `세탁방법 및 취급시 주의사항`,
            placeholder: '',
            value: ``,
        },
        {
            key: `품질 보증기준`,
            placeholder: '',
            value: ``,
        },
        {
            key: `A/S 책임자와 전화번호`,
            placeholder: '',
            value: ``,
        },
        {
            key: `소비자 상담 관련 전화번호`,
            placeholder: '',
            value:
                PLATFORM === 'ru' || PLATFORM === 'jikgu'
                    ? `리유코스메틱 | 062-450-7700`
                    : `주식회사 한국유기농 ｜ 062-450-7700`,
        },
    ],
    children: [
        {
            key: '품명 및 모델명',
            placeholder: '',
            value: '',
        },
        {
            key: '변심반품 택배비',
            placeholder: '',
            value: ``,
        },
        {
            key: '배송',
            placeholder: '',
            value: `주문 및 결제 완료 후 3~7일 이내 출고됩니다.`,
        },
        {
            key: `KC 인증정보 
([어린이제품 안전 특별법]에 따른 안전인증·안전확인·공급자적합성확인대상어린이제품에 한함)`,
            placeholder: '',
            value: ``,
        },
        {
            key: `크기, 중량
(섬유제품 등의 경우 치수 정보로 대체 가능)`,
            placeholder: '',
            value: ``,
        },
        {
            key: '색상',
            placeholder: '',
            value: ``,
        },
        {
            key: '재질 (섬유의 경우 혼용률)',
            placeholder: '',
            value: ``,
        },
        {
            key: `사용연령 또는 권장사용연령`,
            placeholder: '',
            value: ``,
        },
        {
            key: `크기·체중의 한계 (착용 또는 탑승용 어린이제품과 같이 크기·체중에 제한이 있는 품목의 경우 반드시 표시)`,
            placeholder: '',
            value: ``,
        },
        {
            key: `동일모델의 출시년월`,
            placeholder: '',
            value: ``,
        },
        {
            key: `제조자 /수입자`,
            placeholder: '',
            value: ``,
        },
        {
            key: `제조국`,
            placeholder: '',
            value: ``,
        },
        {
            key: `취급방법 및 취급시 주의사항, 안전표시 (주의, 경고 등)`,
            placeholder: '',
            value: ``,
        },
        {
            key: `품질보증기준`,
            placeholder: '',
            value: ``,
        },
        {
            key: `A/S 책임자와 전화번호`,
            placeholder: '',
            value: ``,
        },
        {
            key: `소비자 상담 관련 전화번호`,
            placeholder: '',
            value:
                PLATFORM === 'ru' || PLATFORM === 'jikgu'
                    ? `리유코스메틱 | 062-450-7700`
                    : `주식회사 한국유기농 ｜ 062-450-7700`,
        },
    ],
    appliances: [
        {
            key: '품명 및 모델명',
            placeholder: '',
            value: '',
        },
        {
            key: '변심반품 택배비',
            placeholder: '',
            value: '',
        },
        {
            key: '배송',
            placeholder: '',
            value: '주문 및 결제 완료 후 3~7일 이내 출고됩니다.',
        },
        {
            key: 'KC인증정보([전기용품 및 생활용품 안전관리법]에 따른 안전인증·안전확인·공급자적합성확인대상제품 및 [전파법]에 따른 적합인증·적합등록 대상 기자재에 한함)',
            placeholder: '',
            value: '',
        },
        {
            key: '정격전압, 소비전력 ([에너지이용 합리화법]에 따른 에너지소비효율등급 표시대상 기자재에 한함)',
            placeholder: '',
            value: '',
        },
        {
            key: '동일모델의 출시년월',
            placeholder: '',
            value: '',
        },
        {
            key: '제조자 /수입자',
            placeholder: '',
            value: ``,
        },
        {
            key: '제조국',
            placeholder: '',
            value: ``,
        },
        {
            key: '크기/무게 (무게는 노트북 등 휴대형 기기에 한함)',
            placeholder: '',
            value: ``,
        },
        {
            key: `주요사양`,
            placeholder: '',
            value: ``,
        },
        {
            key: `품질보증기준`,
            placeholder: '',
            value: ``,
        },
        {
            key: `A/S 책임자와 전화번호`,
            placeholder: '',
            value: ``,
        },
        {
            key: `소비자 상담 관련 전화번호`,
            placeholder: '',
            value:
                PLATFORM === 'ru' || PLATFORM === 'jikgu'
                    ? `리유코스메틱 | 062-450-7700`
                    : `주식회사 한국유기농 ｜ 062-450-7700`,
        },
    ],
    food: [
        {
            key: '제품명',
            placeholder: '',
            value: '',
        },
        {
            key: '변심반품 택배비',
            placeholder: '',
            value: '',
        },
        {
            key: '배송',
            placeholder: '',
            value: '주문 및 결제 완료 후 3~7일 이내 출고됩니다.',
        },
        {
            key: '식품의 유형',
            placeholder: '',
            value: '',
        },
        {
            key: '생산자 및 소재지(수입품의 경우 생산자,수입자 및 제조국)',
            placeholder: '',
            value: '',
        },
        {
            key: '제조일 /소비기한',
            placeholder: '',
            value: '',
        },
        {
            key: '포장단위별 내용물의 용량(중량),수량',
            placeholder: '',
            value: ``,
        },
        {
            key: '원재료명 ([농수산물의 원산지 표시 등에 관한 법률]에 따른 원산지 표시 포함) 및 함량(원재료 함량 표시대상 식품에 한함)',
            placeholder: '',
            value: ``,
        },
        {
            key: '영양성분 (영양성분 표시대상 식품에 한함)',
            placeholder: '',
            value: ``,
        },
        {
            key: `유전자변형식품에 해당하는 경우의 표시`,
            placeholder: '',
            value: ``,
        },
        {
            key: `소비자 안전을 위한 주의사항`,
            placeholder: '',
            value: ``,
        },
        {
            key: `수입식품의 경우 “수입식품안전관리 특별법에 따른 수입신고를 필함”의 문구`,
            placeholder: '',
            value: ``,
        },
        {
            key: `소비자 상담 관련 전화번호`,
            placeholder: '',
            value:
                PLATFORM === 'ru' || PLATFORM === 'jikgu'
                    ? `리유코스메틱 | 062-450-7700`
                    : `주식회사 한국유기농 ｜ 062-450-7700`,
        },
        {
            key: `부정불량식품신고`,
            placeholder: '',
            value: `국번없이 1399`,
        },
    ],
};
